package com.nonopn.skywatcher.common.app.pages.map.view.alerts

import com.nonopn.skywatcher.app.utils.DateUtils
import com.nonopn.skywatcher.app.utils.safeLaunch
import eu.codlab.viewmodel.StateHandler
import eu.codlab.viewmodel.StateViewModel
import korlibs.time.DateTime
import kotlinx.coroutines.delay
import kotlinx.coroutines.isActive
import kotlin.time.Duration.Companion.milliseconds

data class FormatEllapsedTimeModelState(
    val ellapsedTime: String? = null
)

class FormatEllapsedTimeModel() : StateViewModel<FormatEllapsedTimeModelState>(
    FormatEllapsedTimeModelState()
), StateHandler<FormatEllapsedTimeModelState> {
    var from: DateTime? = null

    init {
        safeLaunch {
            while (isActive) {
                from?.let {
                    updateState {
                        copy(
                            ellapsedTime = DateUtils.formatEllapsedTime(it, DateTime.now())
                        )
                    }
                }

                delay(400.milliseconds)
            }
        }
    }
}
